import { render, staticRenderFns } from "./dialogWorkFlowLabel.vue?vue&type=template&id=6ae0c412&"
import script from "./dialogWorkFlowLabel.vue?vue&type=script&lang=js&"
export * from "./dialogWorkFlowLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports